export const getNumberOrZeroFromString = (stringVal?: string) => {
  const numberVal = Number(stringVal);
  return isNaN(numberVal) ? 0 : numberVal;
};
